import { render, staticRenderFns } from "./refList.vue?vue&type=template&id=7d6a8f46"
import script from "./refList.vue?vue&type=script&lang=js"
export * from "./refList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports